<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Conversion Log
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="productions"
                outlined
                v-model="form.production_id"
                :items="productionItems"
                label="Production"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.production_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="raw Material"
                outlined
                v-model="form.raw_material_id"
                :items="rawmaterialItems"
                label="Raw Material"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.raw_material_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Conversion Log
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "MaterialConversionLogCreatePage",
  data() {
    return {
      form: {
        production_id: "",
        quantity: 0,
        raw_material_id: "",
      },
      isLoading: false,
      productionItems: [],
      rawmaterialItems: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`material_conversion_logs/masters`)
        .then((masters) => {
          masters = masters.data;

          //productionss masters
          masters.productions.forEach((production) => {
            this.productionItems.push({
              id: production.id,
              text: production.product.name,
              value: production.id,
            });
          });

          //Raw Material masters
          masters.rawmaterials.forEach((rawmaterial) => {
            this.rawmaterialItems.push({
              id: rawmaterial.id,
              text: rawmaterial.name,
              value: rawmaterial.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/material_conversion_logs", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/material-conversion-logs");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
